module.exports = __webpack_public_path__ + "static/media/title.94e88951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.png
// module id = 50
// module chunks = 0